import {isNotNilOrEmpty} from 'ramda-adjunct';

import {EffectivePromoPhotoResponseBody, SaleVehiclePromoPhotoResponseBody} from '@dms/api/vehicle';

import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';
import {SyncedCampaignPromoPhoto, toUnifiedCampaignPromoPhoto} from './toUnifiedCampaignPromoPhoto';
import {RenderedOwnPromoPhoto, toUnifiedOwnPromoPhoto} from './toUnifiedOwnPromoPhoto';

export type SplitEffectivePromoPhotosResult = {
  campaignPromoPhotos: UnifiedAlbumImage[];
  ownPromoPhotos: UnifiedAlbumImage[];
};

export const splitEffectivePromoPhotos = (
  effectivePromoPhotos: EffectivePromoPhotoResponseBody[],
  promotionalPhotos: SaleVehiclePromoPhotoResponseBody[]
) => {
  // READY financing cards come back with source 'own', so they are placed among the own promo tiles.
  const effectiveOwnFileIds = effectivePromoPhotos
    .filter((photo) => photo.source === 'own')
    .map((photo) => photo.fileId);

  // A campaign photo not yet synced to the file store has no url/remoteFileId; rendering it would
  // issue a cookie-bearing GET for a relative, credentialed URL instead of just showing nothing.
  const campaignPromoPhotos = effectivePromoPhotos
    .filter(
      (photo): photo is SyncedCampaignPromoPhoto =>
        photo.source === 'campaign' &&
        isNotNilOrEmpty(photo.url) &&
        isNotNilOrEmpty(photo.remoteFileId)
    )
    .map(toUnifiedCampaignPromoPhoto);

  // A FINANCING card without a rendered file (not READY) is skipped here; the gallery reports it
  // through a financing placeholder tile instead of a broken image.
  const ownPromoPhotos = promotionalPhotos
    .filter(
      (photo): photo is RenderedOwnPromoPhoto =>
        photo.fileId !== null &&
        photo.remoteFileId !== null &&
        photo.url !== null &&
        effectiveOwnFileIds.includes(photo.fileId)
    )
    .map(toUnifiedOwnPromoPhoto);

  return {campaignPromoPhotos, ownPromoPhotos};
};
